import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { ProductionOrderInfo } from '../fragments';

export default gql`
  mutation updateProductionOrder($input: ProductionOrderUpdateInput!) {
    updateProductionOrder(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      productionOrder {
        ...ProductionOrderInfo
      }
    }
  }
  ${ProductionOrderInfo}
  ${ErrorMessageInfo}
`;
